"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaAlunoLogin = exports.yupAlunoLogin = void 0;
const yup = __importStar(require("yup"));
const alunoLogin_1 = require("../enums/alunoLogin");
exports.yupAlunoLogin = yup.object({
    idAluno: yup
        .number()
        .notRequired()
        .transform((v) => (v && isNaN(v) ? undefined : v))
        .label('Aluno'),
    tipo: yup.string().required().default('').label('Tipo').max(30, 'Máximo de 30 caracteres.'),
    email: yup.string().email().default('').label('Email').max(60, 'Máximo de 60 caracteres.'),
    login: yup.string().required().default('').label('Login').max(30, 'Máximo de 30 caracteres.'),
    senha: yup
        .string()
        .test('match', 'A senha é um campo requerido', (v, { parent: { id } }) => {
        return (v && v.length > 0) || id;
    })
        .default('')
        .label('Senha')
        .max(15, 'Máximo de 30 caracteres.'),
    permissao: yup
        .mixed()
        .oneOf(Object.values(alunoLogin_1.ELoginExtraPermissao))
        .default(alunoLogin_1.ELoginExtraPermissao.Todas)
        .label('Permissão'),
    carteirinha: yup.string().default('').label('Carteirinha').max(15, 'Máximo de 15 caracteres.'),
    idImagem: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Imagem Aluno'),
});
exports.schemaAlunoLogin = exports.yupAlunoLogin.shape({});
